import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";
export default {
    namespaced: true,
  state: {
    items: JSON.parse(localStorage.getItem('cartItems')) || [],  // Load cart from localStorage or default to an empty array
  },
  mutations,
  actions,
  getters
};
